'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _createForOfIteratorHelper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var index = require('../migrations/index.js');

var version = require('./repo/version.js');

var errors$1 = require('./errors.js');

var utils = require('./utils.js');

var debug = require('debug');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var debug__default = /*#__PURE__*/_interopDefaultLegacy(debug);

var log = debug__default['default']('ipfs:repo:migrator');

function getLatestMigrationVersion(migrations) {
  migrations = migrations || index;

  if (!Array.isArray(migrations) || migrations.length === 0) {
    return 0;
  }

  return migrations[migrations.length - 1].version;
}

function migrate(_x, _x2, _x3, _x4, _x5) {
  return _migrate.apply(this, arguments);
}

function _migrate() {
  _migrate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(path, backends, repoOptions, toVersion, _ref) {
    var _ref$ignoreLock, ignoreLock, onProgress, _ref$isDryRun, isDryRun, migrations, currentVersion, lock, _iterator2, _step2, _loop, _ret;

    return _regeneratorRuntime.wrap(function _callee$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _ref$ignoreLock = _ref.ignoreLock, ignoreLock = _ref$ignoreLock === void 0 ? false : _ref$ignoreLock, onProgress = _ref.onProgress, _ref$isDryRun = _ref.isDryRun, isDryRun = _ref$isDryRun === void 0 ? false : _ref$isDryRun, migrations = _ref.migrations;
            migrations = migrations || index;

            if (path) {
              _context2.next = 4;
              break;
            }

            throw new errors.RequiredParameterError('Path argument is required!');

          case 4:
            if (repoOptions) {
              _context2.next = 6;
              break;
            }

            throw new errors.RequiredParameterError('repoOptions argument is required!');

          case 6:
            if (toVersion) {
              _context2.next = 8;
              break;
            }

            throw new errors.RequiredParameterError('toVersion argument is required!');

          case 8:
            if (!(!Number.isInteger(toVersion) || toVersion <= 0)) {
              _context2.next = 10;
              break;
            }

            throw new errors.InvalidValueError('Version has to be positive integer!');

          case 10:
            backends = utils.wrapBackends(backends);
            _context2.next = 13;
            return version.getVersion(backends);

          case 13:
            currentVersion = _context2.sent;

            if (!(currentVersion === toVersion)) {
              _context2.next = 17;
              break;
            }

            log('Nothing to migrate.');
            return _context2.abrupt("return");

          case 17:
            if (!(currentVersion > toVersion)) {
              _context2.next = 19;
              break;
            }

            throw new errors.InvalidValueError("Current repo's version (".concat(currentVersion, ") is higher then toVersion (").concat(toVersion, "), you probably wanted to revert it?"));

          case 19:
            verifyAvailableMigrations(migrations, currentVersion, toVersion);

            if (!(!isDryRun && !ignoreLock)) {
              _context2.next = 24;
              break;
            }

            _context2.next = 23;
            return repoOptions.repoLock.lock(path);

          case 23:
            lock = _context2.sent;

          case 24:
            _context2.prev = 24;
            _iterator2 = _createForOfIteratorHelper(migrations);
            _context2.prev = 26;
            _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop() {
              var migration, progressCallback, lastSuccessfullyMigratedVersion;
              return _regeneratorRuntime.wrap(function _loop$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      migration = _step2.value;

                      if (!(toVersion !== undefined && migration.version > toVersion)) {
                        _context.next = 3;
                        break;
                      }

                      return _context.abrupt("return", "break");

                    case 3:
                      if (!(migration.version <= currentVersion)) {
                        _context.next = 5;
                        break;
                      }

                      return _context.abrupt("return", "continue");

                    case 5:
                      log("Migrating version ".concat(migration.version));
                      _context.prev = 6;

                      if (isDryRun) {
                        _context.next = 12;
                        break;
                      }

                      progressCallback = function progressCallback() {};

                      if (onProgress) {
                        progressCallback = function progressCallback(percent, message) {
                          return onProgress(migration.version, percent.toFixed(2), message);
                        };
                      }

                      _context.next = 12;
                      return migration.migrate(backends, progressCallback);

                    case 12:
                      _context.next = 21;
                      break;

                    case 14:
                      _context.prev = 14;
                      _context.t0 = _context["catch"](6);
                      lastSuccessfullyMigratedVersion = migration.version - 1;
                      log("An exception was raised during execution of migration. Setting the repo's version to last successfully migrated version: ".concat(lastSuccessfullyMigratedVersion));
                      _context.next = 20;
                      return version.setVersion(lastSuccessfullyMigratedVersion, backends);

                    case 20:
                      throw new Error("During migration to version ".concat(migration.version, " exception was raised: ").concat(_context.t0.stack || _context.t0.message || _context.t0));

                    case 21:
                      log("Migrating to version ".concat(migration.version, " finished"));

                    case 22:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _loop, null, [[6, 14]]);
            });

            _iterator2.s();

          case 29:
            if ((_step2 = _iterator2.n()).done) {
              _context2.next = 38;
              break;
            }

            return _context2.delegateYield(_loop(), "t0", 31);

          case 31:
            _ret = _context2.t0;

            if (!(_ret === "break")) {
              _context2.next = 34;
              break;
            }

            return _context2.abrupt("break", 38);

          case 34:
            if (!(_ret === "continue")) {
              _context2.next = 36;
              break;
            }

            return _context2.abrupt("continue", 36);

          case 36:
            _context2.next = 29;
            break;

          case 38:
            _context2.next = 43;
            break;

          case 40:
            _context2.prev = 40;
            _context2.t1 = _context2["catch"](26);

            _iterator2.e(_context2.t1);

          case 43:
            _context2.prev = 43;

            _iterator2.f();

            return _context2.finish(43);

          case 46:
            if (isDryRun) {
              _context2.next = 49;
              break;
            }

            _context2.next = 49;
            return version.setVersion(toVersion || getLatestMigrationVersion(migrations), backends);

          case 49:
            log('Repo successfully migrated', toVersion !== undefined ? "to version ".concat(toVersion, "!") : 'to latest version!');

          case 50:
            _context2.prev = 50;

            if (!(!isDryRun && !ignoreLock && lock)) {
              _context2.next = 54;
              break;
            }

            _context2.next = 54;
            return lock.close();

          case 54:
            return _context2.finish(50);

          case 55:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee, null, [[24,, 50, 55], [26, 40, 43, 46]]);
  }));
  return _migrate.apply(this, arguments);
}

function revert(_x6, _x7, _x8, _x9, _x10) {
  return _revert.apply(this, arguments);
}

function _revert() {
  _revert = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(path, backends, repoOptions, toVersion, _ref2) {
    var _ref2$ignoreLock, ignoreLock, onProgress, _ref2$isDryRun, isDryRun, migrations, currentVersion, lock, reversedMigrationArray, _iterator3, _step3, _loop2, _ret2;

    return _regeneratorRuntime.wrap(function _callee2$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _ref2$ignoreLock = _ref2.ignoreLock, ignoreLock = _ref2$ignoreLock === void 0 ? false : _ref2$ignoreLock, onProgress = _ref2.onProgress, _ref2$isDryRun = _ref2.isDryRun, isDryRun = _ref2$isDryRun === void 0 ? false : _ref2$isDryRun, migrations = _ref2.migrations;
            migrations = migrations || index;

            if (path) {
              _context4.next = 4;
              break;
            }

            throw new errors.RequiredParameterError('Path argument is required!');

          case 4:
            if (repoOptions) {
              _context4.next = 6;
              break;
            }

            throw new errors.RequiredParameterError('repoOptions argument is required!');

          case 6:
            if (toVersion) {
              _context4.next = 8;
              break;
            }

            throw new errors.RequiredParameterError('When reverting migrations, you have to specify to which version to revert!');

          case 8:
            if (!(!Number.isInteger(toVersion) || toVersion <= 0)) {
              _context4.next = 10;
              break;
            }

            throw new errors.InvalidValueError('Version has to be positive integer!');

          case 10:
            backends = utils.wrapBackends(backends);
            _context4.next = 13;
            return version.getVersion(backends);

          case 13:
            currentVersion = _context4.sent;

            if (!(currentVersion === toVersion)) {
              _context4.next = 17;
              break;
            }

            log('Nothing to revert.');
            return _context4.abrupt("return");

          case 17:
            if (!(currentVersion < toVersion)) {
              _context4.next = 19;
              break;
            }

            throw new errors.InvalidValueError("Current repo's version (".concat(currentVersion, ") is lower then toVersion (").concat(toVersion, "), you probably wanted to migrate it?"));

          case 19:
            verifyAvailableMigrations(migrations, toVersion, currentVersion, true);

            if (!(!isDryRun && !ignoreLock)) {
              _context4.next = 24;
              break;
            }

            _context4.next = 23;
            return repoOptions.repoLock.lock(path);

          case 23:
            lock = _context4.sent;

          case 24:
            log("Reverting from version ".concat(currentVersion, " to ").concat(toVersion));
            _context4.prev = 25;
            reversedMigrationArray = migrations.slice().reverse();
            _iterator3 = _createForOfIteratorHelper(reversedMigrationArray);
            _context4.prev = 28;
            _loop2 = /*#__PURE__*/_regeneratorRuntime.mark(function _loop2() {
              var migration, progressCallback, lastSuccessfullyRevertedVersion;
              return _regeneratorRuntime.wrap(function _loop2$(_context3) {
                while (1) {
                  switch (_context3.prev = _context3.next) {
                    case 0:
                      migration = _step3.value;

                      if (!(migration.version <= toVersion)) {
                        _context3.next = 3;
                        break;
                      }

                      return _context3.abrupt("return", "break");

                    case 3:
                      if (!(migration.version > currentVersion)) {
                        _context3.next = 5;
                        break;
                      }

                      return _context3.abrupt("return", "continue");

                    case 5:
                      log("Reverting migration version ".concat(migration.version));
                      _context3.prev = 6;

                      if (isDryRun) {
                        _context3.next = 12;
                        break;
                      }

                      progressCallback = function progressCallback() {};

                      if (onProgress) {
                        progressCallback = function progressCallback(percent, message) {
                          return onProgress(migration.version, percent.toFixed(2), message);
                        };
                      }

                      _context3.next = 12;
                      return migration.revert(backends, progressCallback);

                    case 12:
                      _context3.next = 22;
                      break;

                    case 14:
                      _context3.prev = 14;
                      _context3.t0 = _context3["catch"](6);
                      lastSuccessfullyRevertedVersion = migration.version;
                      log("An exception was raised during execution of migration. Setting the repo's version to last successfully reverted version: ".concat(lastSuccessfullyRevertedVersion));
                      _context3.next = 20;
                      return version.setVersion(lastSuccessfullyRevertedVersion, backends);

                    case 20:
                      _context3.t0.message = "During reversion to version ".concat(migration.version, " exception was raised: ").concat(_context3.t0.message);
                      throw _context3.t0;

                    case 22:
                      log("Reverting to version ".concat(migration.version, " finished"));

                    case 23:
                    case "end":
                      return _context3.stop();
                  }
                }
              }, _loop2, null, [[6, 14]]);
            });

            _iterator3.s();

          case 31:
            if ((_step3 = _iterator3.n()).done) {
              _context4.next = 40;
              break;
            }

            return _context4.delegateYield(_loop2(), "t0", 33);

          case 33:
            _ret2 = _context4.t0;

            if (!(_ret2 === "break")) {
              _context4.next = 36;
              break;
            }

            return _context4.abrupt("break", 40);

          case 36:
            if (!(_ret2 === "continue")) {
              _context4.next = 38;
              break;
            }

            return _context4.abrupt("continue", 38);

          case 38:
            _context4.next = 31;
            break;

          case 40:
            _context4.next = 45;
            break;

          case 42:
            _context4.prev = 42;
            _context4.t1 = _context4["catch"](28);

            _iterator3.e(_context4.t1);

          case 45:
            _context4.prev = 45;

            _iterator3.f();

            return _context4.finish(45);

          case 48:
            if (isDryRun) {
              _context4.next = 51;
              break;
            }

            _context4.next = 51;
            return version.setVersion(toVersion, backends);

          case 51:
            log("All migrations successfully reverted to version ".concat(toVersion, "!"));

          case 52:
            _context4.prev = 52;

            if (!(!isDryRun && !ignoreLock && lock)) {
              _context4.next = 56;
              break;
            }

            _context4.next = 56;
            return lock.close();

          case 56:
            return _context4.finish(52);

          case 57:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee2, null, [[25,, 52, 57], [28, 42, 45, 48]]);
  }));
  return _revert.apply(this, arguments);
}

function verifyAvailableMigrations(migrations, fromVersion, toVersion) {
  var checkReversibility = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var migrationCounter = 0;

  var _iterator = _createForOfIteratorHelper(migrations),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var migration = _step.value;

      if (migration.version > toVersion) {
        break;
      }

      if (migration.version > fromVersion) {
        if (checkReversibility && !migration.revert) {
          throw new errors.NonReversibleMigrationError("It is not possible to revert to version ".concat(fromVersion, " because migration version ").concat(migration.version, " is not reversible. Cancelling reversion."));
        }

        migrationCounter++;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  if (migrationCounter !== toVersion - fromVersion) {
    throw new errors.InvalidValueError("The ipfs-repo-migrations package does not have all migration to migrate from version ".concat(fromVersion, " to ").concat(toVersion));
  }
}

var getCurrentRepoVersion = version.getVersion;
var errors = errors$1;
var migrations = index;
exports.errors = errors;
exports.getCurrentRepoVersion = getCurrentRepoVersion;
exports.getLatestMigrationVersion = getLatestMigrationVersion;
exports.migrate = migrate;
exports.migrations = migrations;
exports.revert = revert;